(() => {
  const SELECTOR = '[class*="__text_MDpL4x"], [class*="__text_JzxRWw"]';
  const CHAR_CLASS = 'sr-char';
  const MIN_OPACITY = 0.15;
  const MAX_OPACITY = 1;
  const SMOOTHNESS = 2;

  const splitChars = (root) => {
    if (root.dataset.srProcessed === '1') return;
    root.dataset.srProcessed = '1';

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        if (!node.nodeValue) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const textNodes = [];
    let n;
    while ((n = walker.nextNode())) textNodes.push(n);

    textNodes.forEach((textNode) => {
      const text = textNode.nodeValue;
      if (!text) return;
      const frag = document.createDocumentFragment();
      for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (/\s/.test(ch)) {
          frag.appendChild(document.createTextNode(ch));
        } else {
          const span = document.createElement('span');
          span.className = CHAR_CLASS;
          span.textContent = ch;
          frag.appendChild(span);
        }
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });
  };

  const update = (root) => {
    const chars = root.querySelectorAll('.' + CHAR_CLASS);
    if (!chars.length) return;

    const vh = window.innerHeight || document.documentElement.clientHeight;
    const rect = root.getBoundingClientRect();
    const start = vh * 0.85;
    const end = vh * 0.25;
    const range = start - end;
    const top = rect.top;
    const bottom = rect.bottom;

    let progress;
    if (top >= start) progress = 0;
    else if (bottom <= end) progress = 1;
    else {
      const traveled = start - top;
      const totalTravel = range + (bottom - top);
      progress = Math.max(0, Math.min(1, traveled / totalTravel));
    }

    const total = chars.length;
    const scaled = progress * (total + SMOOTHNESS);

    chars.forEach((char, i) => {
      const t = Math.max(0, Math.min(1, (scaled - i) / SMOOTHNESS));
      const opacity = MIN_OPACITY + (MAX_OPACITY - MIN_OPACITY) * t;
      char.style.opacity = opacity.toFixed(3);
    });
  };

  const roots = new Set();
  let rafId = null;

  const tick = () => {
    rafId = null;
    roots.forEach(update);
  };

  const schedule = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(tick);
  };

  const init = () => {
    const found = document.querySelectorAll(SELECTOR);
    if (!found.length) return;
    found.forEach((root) => {
      splitChars(root);
      roots.add(root);
    });
    roots.forEach(update);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', schedule);
})();
